import Axios from "../../configs/axios.config";

export const createRole = (data) => Axios.post(`/workspace/role`, data).then(response=>response.data.data);
export const updateRole = (data, id) => Axios.put(`/workspace/role/${id}`, data).then(response=>response.data.data);
export const getRoleList = (data) => Axios.get('/workspace/role', { params: data }).then(response=>response.data);
export const getRoleDetail = (id) => Axios.get(`/workspace/role/${id}`).then(response=>response.data);
export const deleteRole = (id) => Axios.delete(`/workspace/role/${id}`);
export const getRolePermissions = () => Axios.get('/workspace/role/permissions').then(response=>response.data);
